import HomePage from "./components/HomePage"
import {BrowserRouter, Routes, Route} from "react-router-dom"
import { useState, useEffect } from "react";
import HourlyInfoPage from "./components/HourlyInfoPage"

export default function App(props){

    let savedZip = localStorage.getItem("savedZip");

    let placeholderLocation = {
        "location": {
            "name": "Las Vegas",
            "region": "Nevada",
            "country": "USA",
            "lat": 36.18,
            "lon": -115.12,
            "tz_id": "America/Los_Angeles",
            "localtime_epoch": 1659549928,
            "localtime": "2022-08-03 11:05"
        },
        "current": {
            "last_updated_epoch": 1659549600,
            "last_updated": "2022-08-03 11:00",
            "temp_c": 33.9,
            "temp_f": 93,
            "is_day": 1,
            "condition": {
                "text": "Partly cloudy",
                "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
                "code": 1003
            },
            "wind_mph": 2.2,
            "wind_kph": 3.6,
            "wind_degree": 142,
            "wind_dir": "SE",
            "pressure_mb": 1014,
            "pressure_in": 29.95,
            "precip_mm": 0,
            "precip_in": 0,
            "humidity": 31,
            "cloud": 75,
            "feelslike_c": 33.6,
            "feelslike_f": 92.5,
            "vis_km": 16,
            "vis_miles": 9,
            "uv": 8,
            "gust_mph": 1.6,
            "gust_kph": 2.5
        },
        "forecast": {
            "forecastday": [
                {
                    "date": "2022-08-03",
                    "date_epoch": 1659484800,
                    "day": {
                        "maxtemp_c": 39.8,
                        "maxtemp_f": 103.6,
                        "mintemp_c": 29.4,
                        "mintemp_f": 84.9,
                        "avgtemp_c": 35,
                        "avgtemp_f": 95.1,
                        "maxwind_mph": 6.5,
                        "maxwind_kph": 10.4,
                        "totalprecip_mm": 0.3,
                        "totalprecip_in": 0.01,
                        "avgvis_km": 10,
                        "avgvis_miles": 6,
                        "avghumidity": 30,
                        "daily_will_it_rain": 1,
                        "daily_chance_of_rain": 81,
                        "daily_will_it_snow": 0,
                        "daily_chance_of_snow": 0,
                        "condition": {
                            "text": "Patchy rain possible",
                            "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                            "code": 1063
                        },
                        "uv": 8
                    },
                    "astro": {
                        "sunrise": "05:50 AM",
                        "sunset": "07:44 PM",
                        "moonrise": "11:29 AM",
                        "moonset": "11:06 PM",
                        "moon_phase": "Waxing Crescent",
                        "moon_illumination": "37"
                    },
                    "hour": [
                        {
                            "time_epoch": 1659510000,
                            "time": "2022-08-03 00:00",
                            "temp_c": 33.2,
                            "temp_f": 91.8,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.4,
                            "wind_kph": 5.4,
                            "wind_degree": 257,
                            "wind_dir": "WSW",
                            "pressure_mb": 1010,
                            "pressure_in": 29.82,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 33,
                            "cloud": 6,
                            "feelslike_c": 33.3,
                            "feelslike_f": 91.9,
                            "windchill_c": 33.2,
                            "windchill_f": 91.8,
                            "heatindex_c": 33.3,
                            "heatindex_f": 91.9,
                            "dewpoint_c": 14.8,
                            "dewpoint_f": 58.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.9,
                            "gust_kph": 7.9,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659513600,
                            "time": "2022-08-03 01:00",
                            "temp_c": 32.9,
                            "temp_f": 91.2,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.3,
                            "wind_kph": 6.8,
                            "wind_degree": 262,
                            "wind_dir": "W",
                            "pressure_mb": 1010,
                            "pressure_in": 29.81,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 33,
                            "cloud": 6,
                            "feelslike_c": 33,
                            "feelslike_f": 91.4,
                            "windchill_c": 32.9,
                            "windchill_f": 91.2,
                            "heatindex_c": 33,
                            "heatindex_f": 91.4,
                            "dewpoint_c": 14.6,
                            "dewpoint_f": 58.3,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.3,
                            "gust_kph": 10.1,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659517200,
                            "time": "2022-08-03 02:00",
                            "temp_c": 31.9,
                            "temp_f": 89.4,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 4.3,
                            "wind_kph": 6.8,
                            "wind_degree": 273,
                            "wind_dir": "W",
                            "pressure_mb": 1009,
                            "pressure_in": 29.8,
                            "precip_mm": 0.2,
                            "precip_in": 0.01,
                            "humidity": 36,
                            "cloud": 75,
                            "feelslike_c": 32,
                            "feelslike_f": 89.6,
                            "windchill_c": 31.9,
                            "windchill_f": 89.4,
                            "heatindex_c": 32,
                            "heatindex_f": 89.6,
                            "dewpoint_c": 14.8,
                            "dewpoint_f": 58.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 65,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.7,
                            "gust_kph": 10.8,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659520800,
                            "time": "2022-08-03 03:00",
                            "temp_c": 31.3,
                            "temp_f": 88.3,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.6,
                            "wind_kph": 5.8,
                            "wind_degree": 286,
                            "wind_dir": "WNW",
                            "pressure_mb": 1009,
                            "pressure_in": 29.8,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 37,
                            "cloud": 10,
                            "feelslike_c": 31.4,
                            "feelslike_f": 88.5,
                            "windchill_c": 31.3,
                            "windchill_f": 88.3,
                            "heatindex_c": 31.4,
                            "heatindex_f": 88.5,
                            "dewpoint_c": 14.9,
                            "dewpoint_f": 58.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6,
                            "gust_kph": 9.7,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659524400,
                            "time": "2022-08-03 04:00",
                            "temp_c": 31,
                            "temp_f": 87.8,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 2.5,
                            "wind_kph": 4,
                            "wind_degree": 289,
                            "wind_dir": "WNW",
                            "pressure_mb": 1009,
                            "pressure_in": 29.8,
                            "precip_mm": 0.1,
                            "precip_in": 0,
                            "humidity": 38,
                            "cloud": 86,
                            "feelslike_c": 31.1,
                            "feelslike_f": 88,
                            "windchill_c": 31,
                            "windchill_f": 87.8,
                            "heatindex_c": 31.1,
                            "heatindex_f": 88,
                            "dewpoint_c": 14.8,
                            "dewpoint_f": 58.6,
                            "will_it_rain": 1,
                            "chance_of_rain": 81,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4,
                            "gust_kph": 6.5,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659528000,
                            "time": "2022-08-03 05:00",
                            "temp_c": 30.1,
                            "temp_f": 86.2,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.5,
                            "wind_kph": 4,
                            "wind_degree": 309,
                            "wind_dir": "NW",
                            "pressure_mb": 1009,
                            "pressure_in": 29.8,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 38,
                            "cloud": 10,
                            "feelslike_c": 30,
                            "feelslike_f": 86,
                            "windchill_c": 30.1,
                            "windchill_f": 86.2,
                            "heatindex_c": 30,
                            "heatindex_f": 86,
                            "dewpoint_c": 14.3,
                            "dewpoint_f": 57.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.5,
                            "gust_kph": 7.2,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659531600,
                            "time": "2022-08-03 06:00",
                            "temp_c": 29.4,
                            "temp_f": 84.9,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.7,
                            "wind_kph": 4.3,
                            "wind_degree": 313,
                            "wind_dir": "NW",
                            "pressure_mb": 1010,
                            "pressure_in": 29.81,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 40,
                            "cloud": 9,
                            "feelslike_c": 29.3,
                            "feelslike_f": 84.7,
                            "windchill_c": 29.4,
                            "windchill_f": 84.9,
                            "heatindex_c": 29.3,
                            "heatindex_f": 84.7,
                            "dewpoint_c": 14.2,
                            "dewpoint_f": 57.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.1,
                            "gust_kph": 8.3,
                            "uv": 7
                        },
                        {
                            "time_epoch": 1659535200,
                            "time": "2022-08-03 07:00",
                            "temp_c": 31.4,
                            "temp_f": 88.5,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2,
                            "wind_kph": 3.2,
                            "wind_degree": 302,
                            "wind_dir": "WNW",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 37,
                            "cloud": 9,
                            "feelslike_c": 31.5,
                            "feelslike_f": 88.7,
                            "windchill_c": 31.4,
                            "windchill_f": 88.5,
                            "heatindex_c": 31.5,
                            "heatindex_f": 88.7,
                            "dewpoint_c": 15,
                            "dewpoint_f": 59,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 2.7,
                            "gust_kph": 4.3,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659538800,
                            "time": "2022-08-03 08:00",
                            "temp_c": 32.5,
                            "temp_f": 90.5,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 1.3,
                            "wind_kph": 2.2,
                            "wind_degree": 302,
                            "wind_dir": "WNW",
                            "pressure_mb": 1011,
                            "pressure_in": 29.84,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 33,
                            "cloud": 9,
                            "feelslike_c": 32.3,
                            "feelslike_f": 90.1,
                            "windchill_c": 32.5,
                            "windchill_f": 90.5,
                            "heatindex_c": 32.3,
                            "heatindex_f": 90.1,
                            "dewpoint_c": 13.9,
                            "dewpoint_f": 57,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 1.6,
                            "gust_kph": 2.5,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659542400,
                            "time": "2022-08-03 09:00",
                            "temp_c": 33.3,
                            "temp_f": 91.9,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 0.4,
                            "wind_kph": 0.7,
                            "wind_degree": 291,
                            "wind_dir": "WNW",
                            "pressure_mb": 1011,
                            "pressure_in": 29.84,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 31,
                            "cloud": 8,
                            "feelslike_c": 33,
                            "feelslike_f": 91.4,
                            "windchill_c": 33.3,
                            "windchill_f": 91.9,
                            "heatindex_c": 33,
                            "heatindex_f": 91.4,
                            "dewpoint_c": 13.8,
                            "dewpoint_f": 56.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 0.4,
                            "gust_kph": 0.7,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659546000,
                            "time": "2022-08-03 10:00",
                            "temp_c": 34,
                            "temp_f": 93.2,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 1.3,
                            "wind_kph": 2.2,
                            "wind_degree": 142,
                            "wind_dir": "SE",
                            "pressure_mb": 1011,
                            "pressure_in": 29.84,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 29,
                            "cloud": 8,
                            "feelslike_c": 33.7,
                            "feelslike_f": 92.7,
                            "windchill_c": 34,
                            "windchill_f": 93.2,
                            "heatindex_c": 33.7,
                            "heatindex_f": 92.7,
                            "dewpoint_c": 13.7,
                            "dewpoint_f": 56.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 1.6,
                            "gust_kph": 2.5,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659549600,
                            "time": "2022-08-03 11:00",
                            "temp_c": 37.6,
                            "temp_f": 99.7,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.1,
                            "wind_kph": 5,
                            "wind_degree": 151,
                            "wind_dir": "SSE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.84,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 28,
                            "cloud": 8,
                            "feelslike_c": 38.9,
                            "feelslike_f": 102,
                            "windchill_c": 37.6,
                            "windchill_f": 99.7,
                            "heatindex_c": 38.9,
                            "heatindex_f": 102,
                            "dewpoint_c": 16.1,
                            "dewpoint_f": 61,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 3.6,
                            "gust_kph": 5.8,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659553200,
                            "time": "2022-08-03 12:00",
                            "temp_c": 38.3,
                            "temp_f": 100.9,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.7,
                            "wind_kph": 7.6,
                            "wind_degree": 158,
                            "wind_dir": "SSE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 27,
                            "cloud": 8,
                            "feelslike_c": 39.7,
                            "feelslike_f": 103.5,
                            "windchill_c": 38.3,
                            "windchill_f": 100.9,
                            "heatindex_c": 39.7,
                            "heatindex_f": 103.5,
                            "dewpoint_c": 16,
                            "dewpoint_f": 60.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.4,
                            "gust_kph": 8.6,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659556800,
                            "time": "2022-08-03 13:00",
                            "temp_c": 39,
                            "temp_f": 102.2,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 6.5,
                            "wind_kph": 10.4,
                            "wind_degree": 170,
                            "wind_dir": "S",
                            "pressure_mb": 1010,
                            "pressure_in": 29.81,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 26,
                            "cloud": 9,
                            "feelslike_c": 40.4,
                            "feelslike_f": 104.7,
                            "windchill_c": 39,
                            "windchill_f": 102.2,
                            "heatindex_c": 40.4,
                            "heatindex_f": 104.7,
                            "dewpoint_c": 15.9,
                            "dewpoint_f": 60.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 7.4,
                            "gust_kph": 11.9,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659560400,
                            "time": "2022-08-03 14:00",
                            "temp_c": 39.5,
                            "temp_f": 103.1,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 6.3,
                            "wind_kph": 10.1,
                            "wind_degree": 185,
                            "wind_dir": "S",
                            "pressure_mb": 1009,
                            "pressure_in": 29.79,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 25,
                            "cloud": 11,
                            "feelslike_c": 40.8,
                            "feelslike_f": 105.4,
                            "windchill_c": 39.5,
                            "windchill_f": 103.1,
                            "heatindex_c": 40.8,
                            "heatindex_f": 105.4,
                            "dewpoint_c": 15.6,
                            "dewpoint_f": 60.1,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 7.2,
                            "gust_kph": 11.5,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659564000,
                            "time": "2022-08-03 15:00",
                            "temp_c": 39.8,
                            "temp_f": 103.6,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.8,
                            "wind_kph": 9.4,
                            "wind_degree": 202,
                            "wind_dir": "SSW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.76,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 24,
                            "cloud": 11,
                            "feelslike_c": 40.9,
                            "feelslike_f": 105.6,
                            "windchill_c": 39.8,
                            "windchill_f": 103.6,
                            "heatindex_c": 40.9,
                            "heatindex_f": 105.6,
                            "dewpoint_c": 15.2,
                            "dewpoint_f": 59.4,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.7,
                            "gust_kph": 10.8,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659567600,
                            "time": "2022-08-03 16:00",
                            "temp_c": 39.8,
                            "temp_f": 103.6,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.6,
                            "wind_kph": 9,
                            "wind_degree": 211,
                            "wind_dir": "SSW",
                            "pressure_mb": 1007,
                            "pressure_in": 29.74,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 23,
                            "cloud": 9,
                            "feelslike_c": 40.5,
                            "feelslike_f": 104.9,
                            "windchill_c": 39.8,
                            "windchill_f": 103.6,
                            "heatindex_c": 40.5,
                            "heatindex_f": 104.9,
                            "dewpoint_c": 14.5,
                            "dewpoint_f": 58.1,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.5,
                            "gust_kph": 10.4,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659571200,
                            "time": "2022-08-03 17:00",
                            "temp_c": 39.4,
                            "temp_f": 102.9,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.8,
                            "wind_kph": 9.4,
                            "wind_degree": 217,
                            "wind_dir": "SW",
                            "pressure_mb": 1006,
                            "pressure_in": 29.72,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 22,
                            "cloud": 7,
                            "feelslike_c": 39.6,
                            "feelslike_f": 103.3,
                            "windchill_c": 39.4,
                            "windchill_f": 102.9,
                            "heatindex_c": 39.6,
                            "heatindex_f": 103.3,
                            "dewpoint_c": 13.5,
                            "dewpoint_f": 56.3,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.7,
                            "gust_kph": 10.8,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659574800,
                            "time": "2022-08-03 18:00",
                            "temp_c": 38.7,
                            "temp_f": 101.7,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.8,
                            "wind_kph": 6.1,
                            "wind_degree": 223,
                            "wind_dir": "SW",
                            "pressure_mb": 1006,
                            "pressure_in": 29.71,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 21,
                            "cloud": 6,
                            "feelslike_c": 38.4,
                            "feelslike_f": 101.1,
                            "windchill_c": 38.7,
                            "windchill_f": 101.7,
                            "heatindex_c": 38.4,
                            "heatindex_f": 101.1,
                            "dewpoint_c": 12.7,
                            "dewpoint_f": 54.9,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.5,
                            "gust_kph": 7.2,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659578400,
                            "time": "2022-08-03 19:00",
                            "temp_c": 37.7,
                            "temp_f": 99.9,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.7,
                            "wind_kph": 4.3,
                            "wind_degree": 179,
                            "wind_dir": "S",
                            "pressure_mb": 1006,
                            "pressure_in": 29.72,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 22,
                            "cloud": 7,
                            "feelslike_c": 37.3,
                            "feelslike_f": 99.1,
                            "windchill_c": 37.7,
                            "windchill_f": 99.9,
                            "heatindex_c": 37.3,
                            "heatindex_f": 99.1,
                            "dewpoint_c": 12.6,
                            "dewpoint_f": 54.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 3.1,
                            "gust_kph": 5,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659582000,
                            "time": "2022-08-03 20:00",
                            "temp_c": 36.1,
                            "temp_f": 97,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.7,
                            "wind_kph": 4.3,
                            "wind_degree": 174,
                            "wind_dir": "S",
                            "pressure_mb": 1007,
                            "pressure_in": 29.73,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 26,
                            "cloud": 8,
                            "feelslike_c": 35.9,
                            "feelslike_f": 96.6,
                            "windchill_c": 36.1,
                            "windchill_f": 97,
                            "heatindex_c": 35.9,
                            "heatindex_f": 96.6,
                            "dewpoint_c": 13.5,
                            "dewpoint_f": 56.3,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 3.6,
                            "gust_kph": 5.8,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659585600,
                            "time": "2022-08-03 21:00",
                            "temp_c": 35.4,
                            "temp_f": 95.7,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.1,
                            "wind_kph": 5,
                            "wind_degree": 189,
                            "wind_dir": "S",
                            "pressure_mb": 1007,
                            "pressure_in": 29.74,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 28,
                            "cloud": 8,
                            "feelslike_c": 35.4,
                            "feelslike_f": 95.7,
                            "windchill_c": 35.4,
                            "windchill_f": 95.7,
                            "heatindex_c": 35.4,
                            "heatindex_f": 95.7,
                            "dewpoint_c": 13.9,
                            "dewpoint_f": 57,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.5,
                            "gust_kph": 7.2,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659589200,
                            "time": "2022-08-03 22:00",
                            "temp_c": 34.7,
                            "temp_f": 94.5,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.8,
                            "wind_kph": 6.1,
                            "wind_degree": 217,
                            "wind_dir": "SW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.76,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 29,
                            "cloud": 6,
                            "feelslike_c": 34.6,
                            "feelslike_f": 94.3,
                            "windchill_c": 34.7,
                            "windchill_f": 94.5,
                            "heatindex_c": 34.6,
                            "heatindex_f": 94.3,
                            "dewpoint_c": 14,
                            "dewpoint_f": 57.2,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.6,
                            "gust_kph": 9,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659592800,
                            "time": "2022-08-03 23:00",
                            "temp_c": 33.8,
                            "temp_f": 92.8,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.4,
                            "wind_kph": 5.4,
                            "wind_degree": 241,
                            "wind_dir": "WSW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.76,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 6,
                            "feelslike_c": 33.6,
                            "feelslike_f": 92.5,
                            "windchill_c": 33.8,
                            "windchill_f": 92.8,
                            "heatindex_c": 33.6,
                            "heatindex_f": 92.5,
                            "dewpoint_c": 13.8,
                            "dewpoint_f": 56.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.4,
                            "gust_kph": 8.6,
                            "uv": 1
                        }
                    ]
                },
                {
                    "date": "2022-08-04",
                    "date_epoch": 1659571200,
                    "day": {
                        "maxtemp_c": 37.7,
                        "maxtemp_f": 99.9,
                        "mintemp_c": 29,
                        "mintemp_f": 84.2,
                        "avgtemp_c": 32.8,
                        "avgtemp_f": 91.1,
                        "maxwind_mph": 19.2,
                        "maxwind_kph": 31,
                        "totalprecip_mm": 4.2,
                        "totalprecip_in": 0.17,
                        "avgvis_km": 9.8,
                        "avgvis_miles": 6,
                        "avghumidity": 36,
                        "daily_will_it_rain": 1,
                        "daily_chance_of_rain": 86,
                        "daily_will_it_snow": 0,
                        "daily_chance_of_snow": 0,
                        "condition": {
                            "text": "Patchy rain possible",
                            "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                            "code": 1063
                        },
                        "uv": 7
                    },
                    "astro": {
                        "sunrise": "05:51 AM",
                        "sunset": "07:43 PM",
                        "moonrise": "12:33 PM",
                        "moonset": "11:35 PM",
                        "moon_phase": "First Quarter",
                        "moon_illumination": "44"
                    },
                    "hour": [
                        {
                            "time_epoch": 1659596400,
                            "time": "2022-08-04 00:00",
                            "temp_c": 33,
                            "temp_f": 91.4,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.7,
                            "wind_kph": 4.3,
                            "wind_degree": 203,
                            "wind_dir": "SSW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 32,
                            "cloud": 12,
                            "feelslike_c": 32.8,
                            "feelslike_f": 91,
                            "windchill_c": 33,
                            "windchill_f": 91.4,
                            "heatindex_c": 32.8,
                            "heatindex_f": 91,
                            "dewpoint_c": 14.1,
                            "dewpoint_f": 57.4,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.5,
                            "gust_kph": 7.2,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659600000,
                            "time": "2022-08-04 01:00",
                            "temp_c": 32,
                            "temp_f": 89.6,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.3,
                            "wind_kph": 6.8,
                            "wind_degree": 169,
                            "wind_dir": "S",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 34,
                            "cloud": 6,
                            "feelslike_c": 31.8,
                            "feelslike_f": 89.2,
                            "windchill_c": 32,
                            "windchill_f": 89.6,
                            "heatindex_c": 31.8,
                            "heatindex_f": 89.2,
                            "dewpoint_c": 14,
                            "dewpoint_f": 57.2,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 7.4,
                            "gust_kph": 11.9,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659603600,
                            "time": "2022-08-04 02:00",
                            "temp_c": 31.2,
                            "temp_f": 88.2,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.1,
                            "wind_kph": 8.3,
                            "wind_degree": 162,
                            "wind_dir": "SSE",
                            "pressure_mb": 1008,
                            "pressure_in": 29.78,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 36,
                            "cloud": 7,
                            "feelslike_c": 31,
                            "feelslike_f": 87.8,
                            "windchill_c": 31.2,
                            "windchill_f": 88.2,
                            "heatindex_c": 31,
                            "heatindex_f": 87.8,
                            "dewpoint_c": 14.2,
                            "dewpoint_f": 57.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 9.2,
                            "gust_kph": 14.8,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659607200,
                            "time": "2022-08-04 03:00",
                            "temp_c": 30.4,
                            "temp_f": 86.7,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.6,
                            "wind_kph": 9,
                            "wind_degree": 183,
                            "wind_dir": "S",
                            "pressure_mb": 1009,
                            "pressure_in": 29.78,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 38,
                            "cloud": 7,
                            "feelslike_c": 30.3,
                            "feelslike_f": 86.5,
                            "windchill_c": 30.4,
                            "windchill_f": 86.7,
                            "heatindex_c": 30.3,
                            "heatindex_f": 86.5,
                            "dewpoint_c": 14.4,
                            "dewpoint_f": 57.9,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 9.8,
                            "gust_kph": 15.8,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659610800,
                            "time": "2022-08-04 04:00",
                            "temp_c": 29.8,
                            "temp_f": 85.6,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.4,
                            "wind_kph": 8.6,
                            "wind_degree": 216,
                            "wind_dir": "SW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 38,
                            "cloud": 8,
                            "feelslike_c": 29.7,
                            "feelslike_f": 85.5,
                            "windchill_c": 29.8,
                            "windchill_f": 85.6,
                            "heatindex_c": 29.7,
                            "heatindex_f": 85.5,
                            "dewpoint_c": 14.2,
                            "dewpoint_f": 57.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 10.1,
                            "gust_kph": 16.2,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659614400,
                            "time": "2022-08-04 05:00",
                            "temp_c": 29.5,
                            "temp_f": 85.1,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.1,
                            "wind_kph": 5,
                            "wind_degree": 221,
                            "wind_dir": "SW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 39,
                            "cloud": 16,
                            "feelslike_c": 29.4,
                            "feelslike_f": 84.9,
                            "windchill_c": 29.5,
                            "windchill_f": 85.1,
                            "heatindex_c": 29.4,
                            "heatindex_f": 84.9,
                            "dewpoint_c": 14.1,
                            "dewpoint_f": 57.4,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.8,
                            "gust_kph": 9.4,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659618000,
                            "time": "2022-08-04 06:00",
                            "temp_c": 29,
                            "temp_f": 84.2,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.7,
                            "wind_kph": 4.3,
                            "wind_degree": 184,
                            "wind_dir": "S",
                            "pressure_mb": 1009,
                            "pressure_in": 29.79,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 41,
                            "cloud": 24,
                            "feelslike_c": 29,
                            "feelslike_f": 84.2,
                            "windchill_c": 29,
                            "windchill_f": 84.2,
                            "heatindex_c": 29,
                            "heatindex_f": 84.2,
                            "dewpoint_c": 14.3,
                            "dewpoint_f": 57.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.9,
                            "gust_kph": 7.9,
                            "uv": 7
                        },
                        {
                            "time_epoch": 1659621600,
                            "time": "2022-08-04 07:00",
                            "temp_c": 30.8,
                            "temp_f": 87.4,
                            "is_day": 1,
                            "condition": {
                                "text": "Partly cloudy",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
                                "code": 1003
                            },
                            "wind_mph": 3.4,
                            "wind_kph": 5.4,
                            "wind_degree": 167,
                            "wind_dir": "SSE",
                            "pressure_mb": 1009,
                            "pressure_in": 29.8,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 39,
                            "cloud": 31,
                            "feelslike_c": 31.1,
                            "feelslike_f": 88,
                            "windchill_c": 30.8,
                            "windchill_f": 87.4,
                            "heatindex_c": 31.1,
                            "heatindex_f": 88,
                            "dewpoint_c": 15.4,
                            "dewpoint_f": 59.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.5,
                            "gust_kph": 7.2,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659625200,
                            "time": "2022-08-04 08:00",
                            "temp_c": 31.3,
                            "temp_f": 88.3,
                            "is_day": 1,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                                "code": 1063
                            },
                            "wind_mph": 4.9,
                            "wind_kph": 7.9,
                            "wind_degree": 130,
                            "wind_dir": "SE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0.1,
                            "precip_in": 0,
                            "humidity": 38,
                            "cloud": 75,
                            "feelslike_c": 31.5,
                            "feelslike_f": 88.7,
                            "windchill_c": 31.3,
                            "windchill_f": 88.3,
                            "heatindex_c": 31.5,
                            "heatindex_f": 88.7,
                            "dewpoint_c": 15.2,
                            "dewpoint_f": 59.4,
                            "will_it_rain": 1,
                            "chance_of_rain": 86,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.6,
                            "gust_kph": 9,
                            "uv": 7
                        },
                        {
                            "time_epoch": 1659628800,
                            "time": "2022-08-04 09:00",
                            "temp_c": 31.4,
                            "temp_f": 88.5,
                            "is_day": 1,
                            "condition": {
                                "text": "Partly cloudy",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
                                "code": 1003
                            },
                            "wind_mph": 3.6,
                            "wind_kph": 5.8,
                            "wind_degree": 123,
                            "wind_dir": "ESE",
                            "pressure_mb": 1011,
                            "pressure_in": 29.85,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 38,
                            "cloud": 25,
                            "feelslike_c": 31.6,
                            "feelslike_f": 88.9,
                            "windchill_c": 31.4,
                            "windchill_f": 88.5,
                            "heatindex_c": 31.6,
                            "heatindex_f": 88.9,
                            "dewpoint_c": 15.2,
                            "dewpoint_f": 59.4,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4,
                            "gust_kph": 6.5,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659632400,
                            "time": "2022-08-04 10:00",
                            "temp_c": 32.5,
                            "temp_f": 90.5,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 1.6,
                            "wind_kph": 2.5,
                            "wind_degree": 135,
                            "wind_dir": "SE",
                            "pressure_mb": 1011,
                            "pressure_in": 29.85,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 35,
                            "cloud": 17,
                            "feelslike_c": 32.6,
                            "feelslike_f": 90.7,
                            "windchill_c": 32.5,
                            "windchill_f": 90.5,
                            "heatindex_c": 32.6,
                            "heatindex_f": 90.7,
                            "dewpoint_c": 14.9,
                            "dewpoint_f": 58.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 1.8,
                            "gust_kph": 2.9,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659636000,
                            "time": "2022-08-04 11:00",
                            "temp_c": 36.5,
                            "temp_f": 97.7,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 0.4,
                            "wind_kph": 0.7,
                            "wind_degree": 321,
                            "wind_dir": "NW",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 32,
                            "cloud": 15,
                            "feelslike_c": 38.3,
                            "feelslike_f": 100.9,
                            "windchill_c": 36.5,
                            "windchill_f": 97.7,
                            "heatindex_c": 38.3,
                            "heatindex_f": 100.9,
                            "dewpoint_c": 17.2,
                            "dewpoint_f": 63,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 0.4,
                            "gust_kph": 0.7,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659639600,
                            "time": "2022-08-04 12:00",
                            "temp_c": 35.6,
                            "temp_f": 96.1,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2,
                            "wind_kph": 3.2,
                            "wind_degree": 95,
                            "wind_dir": "E",
                            "pressure_mb": 1010,
                            "pressure_in": 29.82,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 17,
                            "feelslike_c": 36.2,
                            "feelslike_f": 97.2,
                            "windchill_c": 35.6,
                            "windchill_f": 96.1,
                            "heatindex_c": 36.2,
                            "heatindex_f": 97.2,
                            "dewpoint_c": 15.3,
                            "dewpoint_f": 59.5,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 2.2,
                            "gust_kph": 3.6,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659643200,
                            "time": "2022-08-04 13:00",
                            "temp_c": 36.5,
                            "temp_f": 97.7,
                            "is_day": 1,
                            "condition": {
                                "text": "Partly cloudy",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
                                "code": 1003
                            },
                            "wind_mph": 9.4,
                            "wind_kph": 15.1,
                            "wind_degree": 120,
                            "wind_dir": "ESE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.82,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 27,
                            "cloud": 47,
                            "feelslike_c": 36.9,
                            "feelslike_f": 98.4,
                            "windchill_c": 36.5,
                            "windchill_f": 97.7,
                            "heatindex_c": 36.9,
                            "heatindex_f": 98.4,
                            "dewpoint_c": 14.6,
                            "dewpoint_f": 58.3,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 10.7,
                            "gust_kph": 17.3,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659646800,
                            "time": "2022-08-04 14:00",
                            "temp_c": 35.8,
                            "temp_f": 96.4,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 19.2,
                            "wind_kph": 31,
                            "wind_degree": 117,
                            "wind_dir": "ESE",
                            "pressure_mb": 1009,
                            "pressure_in": 29.81,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 17,
                            "feelslike_c": 36.7,
                            "feelslike_f": 98.1,
                            "windchill_c": 35.8,
                            "windchill_f": 96.4,
                            "heatindex_c": 36.7,
                            "heatindex_f": 98.1,
                            "dewpoint_c": 15.8,
                            "dewpoint_f": 60.4,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 22.1,
                            "gust_kph": 35.6,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659650400,
                            "time": "2022-08-04 15:00",
                            "temp_c": 37.7,
                            "temp_f": 99.9,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 15.7,
                            "wind_kph": 25.2,
                            "wind_degree": 123,
                            "wind_dir": "ESE",
                            "pressure_mb": 1008,
                            "pressure_in": 29.78,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 31,
                            "cloud": 11,
                            "feelslike_c": 40.2,
                            "feelslike_f": 104.4,
                            "windchill_c": 37.7,
                            "windchill_f": 99.9,
                            "heatindex_c": 40.2,
                            "heatindex_f": 104.4,
                            "dewpoint_c": 17.8,
                            "dewpoint_f": 64,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 18.1,
                            "gust_kph": 29.2,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659654000,
                            "time": "2022-08-04 16:00",
                            "temp_c": 35.9,
                            "temp_f": 96.6,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 9.6,
                            "wind_kph": 15.5,
                            "wind_degree": 128,
                            "wind_dir": "SE",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 24,
                            "feelslike_c": 36.6,
                            "feelslike_f": 97.9,
                            "windchill_c": 35.9,
                            "windchill_f": 96.6,
                            "heatindex_c": 36.6,
                            "heatindex_f": 97.9,
                            "dewpoint_c": 15.5,
                            "dewpoint_f": 59.9,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 11.2,
                            "gust_kph": 18,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659657600,
                            "time": "2022-08-04 17:00",
                            "temp_c": 37.3,
                            "temp_f": 99.1,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 5.8,
                            "wind_kph": 9.4,
                            "wind_degree": 143,
                            "wind_dir": "SE",
                            "pressure_mb": 1007,
                            "pressure_in": 29.73,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 11,
                            "feelslike_c": 38.9,
                            "feelslike_f": 102,
                            "windchill_c": 37.3,
                            "windchill_f": 99.1,
                            "heatindex_c": 38.9,
                            "heatindex_f": 102,
                            "dewpoint_c": 16.6,
                            "dewpoint_f": 61.9,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.7,
                            "gust_kph": 10.8,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659661200,
                            "time": "2022-08-04 18:00",
                            "temp_c": 35.3,
                            "temp_f": 95.5,
                            "is_day": 1,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                                "code": 1063
                            },
                            "wind_mph": 11.4,
                            "wind_kph": 18.4,
                            "wind_degree": 107,
                            "wind_dir": "ESE",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0.3,
                            "precip_in": 0.01,
                            "humidity": 30,
                            "cloud": 77,
                            "feelslike_c": 35.9,
                            "feelslike_f": 96.6,
                            "windchill_c": 35.3,
                            "windchill_f": 95.5,
                            "heatindex_c": 35.9,
                            "heatindex_f": 96.6,
                            "dewpoint_c": 15.3,
                            "dewpoint_f": 59.5,
                            "will_it_rain": 0,
                            "chance_of_rain": 67,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 13.4,
                            "gust_kph": 21.6,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659664800,
                            "time": "2022-08-04 19:00",
                            "temp_c": 33.7,
                            "temp_f": 92.7,
                            "is_day": 1,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                                "code": 1063
                            },
                            "wind_mph": 11.9,
                            "wind_kph": 19.1,
                            "wind_degree": 102,
                            "wind_dir": "ESE",
                            "pressure_mb": 1008,
                            "pressure_in": 29.76,
                            "precip_mm": 0.1,
                            "precip_in": 0,
                            "humidity": 34,
                            "cloud": 84,
                            "feelslike_c": 34.2,
                            "feelslike_f": 93.6,
                            "windchill_c": 33.7,
                            "windchill_f": 92.7,
                            "heatindex_c": 34.2,
                            "heatindex_f": 93.6,
                            "dewpoint_c": 15.4,
                            "dewpoint_f": 59.7,
                            "will_it_rain": 1,
                            "chance_of_rain": 85,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 13.6,
                            "gust_kph": 22,
                            "uv": 7
                        },
                        {
                            "time_epoch": 1659668400,
                            "time": "2022-08-04 20:00",
                            "temp_c": 32,
                            "temp_f": 89.6,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 6.7,
                            "wind_kph": 10.8,
                            "wind_degree": 118,
                            "wind_dir": "ESE",
                            "pressure_mb": 1009,
                            "pressure_in": 29.78,
                            "precip_mm": 1.4,
                            "precip_in": 0.06,
                            "humidity": 38,
                            "cloud": 73,
                            "feelslike_c": 32.6,
                            "feelslike_f": 90.7,
                            "windchill_c": 32,
                            "windchill_f": 89.6,
                            "heatindex_c": 32.6,
                            "heatindex_f": 90.7,
                            "dewpoint_c": 16,
                            "dewpoint_f": 60.8,
                            "will_it_rain": 1,
                            "chance_of_rain": 77,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 9.4,
                            "gust_kph": 15.1,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659672000,
                            "time": "2022-08-04 21:00",
                            "temp_c": 30.9,
                            "temp_f": 87.6,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 1.8,
                            "wind_kph": 2.9,
                            "wind_degree": 249,
                            "wind_dir": "WSW",
                            "pressure_mb": 1009,
                            "pressure_in": 29.81,
                            "precip_mm": 0.4,
                            "precip_in": 0.02,
                            "humidity": 43,
                            "cloud": 85,
                            "feelslike_c": 31.7,
                            "feelslike_f": 89.1,
                            "windchill_c": 30.9,
                            "windchill_f": 87.6,
                            "heatindex_c": 31.7,
                            "heatindex_f": 89.1,
                            "dewpoint_c": 16.8,
                            "dewpoint_f": 62.2,
                            "will_it_rain": 1,
                            "chance_of_rain": 77,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 2.5,
                            "gust_kph": 4,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659675600,
                            "time": "2022-08-04 22:00",
                            "temp_c": 30.1,
                            "temp_f": 86.2,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 2.9,
                            "wind_kph": 4.7,
                            "wind_degree": 238,
                            "wind_dir": "WSW",
                            "pressure_mb": 1010,
                            "pressure_in": 29.82,
                            "precip_mm": 0.5,
                            "precip_in": 0.02,
                            "humidity": 46,
                            "cloud": 84,
                            "feelslike_c": 31,
                            "feelslike_f": 87.8,
                            "windchill_c": 30.1,
                            "windchill_f": 86.2,
                            "heatindex_c": 31,
                            "heatindex_f": 87.8,
                            "dewpoint_c": 17.1,
                            "dewpoint_f": 62.8,
                            "will_it_rain": 1,
                            "chance_of_rain": 84,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 4.7,
                            "gust_kph": 7.6,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659679200,
                            "time": "2022-08-04 23:00",
                            "temp_c": 30,
                            "temp_f": 86,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 1.3,
                            "wind_kph": 2.2,
                            "wind_degree": 314,
                            "wind_dir": "NW",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 1.4,
                            "precip_in": 0.06,
                            "humidity": 47,
                            "cloud": 75,
                            "feelslike_c": 31.1,
                            "feelslike_f": 88,
                            "windchill_c": 30,
                            "windchill_f": 86,
                            "heatindex_c": 31.1,
                            "heatindex_f": 88,
                            "dewpoint_c": 17.6,
                            "dewpoint_f": 63.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 66,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 1.8,
                            "gust_kph": 2.9,
                            "uv": 1
                        }
                    ]
                },
                {
                    "date": "2022-08-05",
                    "date_epoch": 1659657600,
                    "day": {
                        "maxtemp_c": 39.5,
                        "maxtemp_f": 103.1,
                        "mintemp_c": 27,
                        "mintemp_f": 80.6,
                        "avgtemp_c": 32.6,
                        "avgtemp_f": 90.6,
                        "maxwind_mph": 8.7,
                        "maxwind_kph": 14,
                        "totalprecip_mm": 1.6,
                        "totalprecip_in": 0.06,
                        "avgvis_km": 9.9,
                        "avgvis_miles": 6,
                        "avghumidity": 40,
                        "daily_will_it_rain": 1,
                        "daily_chance_of_rain": 89,
                        "daily_will_it_snow": 0,
                        "daily_chance_of_snow": 0,
                        "condition": {
                            "text": "Patchy rain possible",
                            "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                            "code": 1063
                        },
                        "uv": 7
                    },
                    "astro": {
                        "sunrise": "05:51 AM",
                        "sunset": "07:42 PM",
                        "moonrise": "01:41 PM",
                        "moonset": "No moonset",
                        "moon_phase": "First Quarter",
                        "moon_illumination": "51"
                    },
                    "hour": [
                        {
                            "time_epoch": 1659682800,
                            "time": "2022-08-05 00:00",
                            "temp_c": 29.6,
                            "temp_f": 85.3,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 0.7,
                            "wind_kph": 1.1,
                            "wind_degree": 34,
                            "wind_dir": "NE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0.2,
                            "precip_in": 0.01,
                            "humidity": 49,
                            "cloud": 87,
                            "feelslike_c": 30.8,
                            "feelslike_f": 87.4,
                            "windchill_c": 29.6,
                            "windchill_f": 85.3,
                            "heatindex_c": 30.8,
                            "heatindex_f": 87.4,
                            "dewpoint_c": 17.8,
                            "dewpoint_f": 64,
                            "will_it_rain": 1,
                            "chance_of_rain": 72,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 0.9,
                            "gust_kph": 1.4,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659686400,
                            "time": "2022-08-05 01:00",
                            "temp_c": 29.3,
                            "temp_f": 84.7,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 0.7,
                            "wind_kph": 1.1,
                            "wind_degree": 81,
                            "wind_dir": "E",
                            "pressure_mb": 1010,
                            "pressure_in": 29.82,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 50,
                            "cloud": 11,
                            "feelslike_c": 30.5,
                            "feelslike_f": 86.9,
                            "windchill_c": 29.3,
                            "windchill_f": 84.7,
                            "heatindex_c": 30.5,
                            "heatindex_f": 86.9,
                            "dewpoint_c": 17.9,
                            "dewpoint_f": 64.2,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 0.9,
                            "gust_kph": 1.4,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659690000,
                            "time": "2022-08-05 02:00",
                            "temp_c": 29.1,
                            "temp_f": 84.4,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 2.2,
                            "wind_kph": 3.6,
                            "wind_degree": 103,
                            "wind_dir": "ESE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.82,
                            "precip_mm": 0.3,
                            "precip_in": 0.01,
                            "humidity": 51,
                            "cloud": 79,
                            "feelslike_c": 30.3,
                            "feelslike_f": 86.5,
                            "windchill_c": 29.1,
                            "windchill_f": 84.4,
                            "heatindex_c": 30.3,
                            "heatindex_f": 86.5,
                            "dewpoint_c": 17.9,
                            "dewpoint_f": 64.2,
                            "will_it_rain": 1,
                            "chance_of_rain": 89,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 2.7,
                            "gust_kph": 4.3,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659693600,
                            "time": "2022-08-05 03:00",
                            "temp_c": 28.5,
                            "temp_f": 83.3,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.2,
                            "wind_kph": 3.6,
                            "wind_degree": 16,
                            "wind_dir": "NNE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 54,
                            "cloud": 18,
                            "feelslike_c": 29.8,
                            "feelslike_f": 85.6,
                            "windchill_c": 28.5,
                            "windchill_f": 83.3,
                            "heatindex_c": 29.8,
                            "heatindex_f": 85.6,
                            "dewpoint_c": 18.2,
                            "dewpoint_f": 64.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 2.7,
                            "gust_kph": 4.3,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659697200,
                            "time": "2022-08-05 04:00",
                            "temp_c": 27.9,
                            "temp_f": 82.2,
                            "is_day": 0,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/176.png",
                                "code": 1063
                            },
                            "wind_mph": 6.3,
                            "wind_kph": 10.1,
                            "wind_degree": 19,
                            "wind_dir": "NNE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0.2,
                            "precip_in": 0.01,
                            "humidity": 55,
                            "cloud": 79,
                            "feelslike_c": 29.1,
                            "feelslike_f": 84.4,
                            "windchill_c": 27.9,
                            "windchill_f": 82.2,
                            "heatindex_c": 29.1,
                            "heatindex_f": 84.4,
                            "dewpoint_c": 18.1,
                            "dewpoint_f": 64.6,
                            "will_it_rain": 1,
                            "chance_of_rain": 81,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 8.3,
                            "gust_kph": 13.3,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659700800,
                            "time": "2022-08-05 05:00",
                            "temp_c": 27.1,
                            "temp_f": 80.8,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.9,
                            "wind_kph": 7.9,
                            "wind_degree": 11,
                            "wind_dir": "NNE",
                            "pressure_mb": 1011,
                            "pressure_in": 29.85,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 58,
                            "cloud": 14,
                            "feelslike_c": 28.3,
                            "feelslike_f": 82.9,
                            "windchill_c": 27.1,
                            "windchill_f": 80.8,
                            "heatindex_c": 28.3,
                            "heatindex_f": 82.9,
                            "dewpoint_c": 18.1,
                            "dewpoint_f": 64.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6,
                            "gust_kph": 9.7,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659704400,
                            "time": "2022-08-05 06:00",
                            "temp_c": 27,
                            "temp_f": 80.6,
                            "is_day": 1,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                                "code": 1063
                            },
                            "wind_mph": 2.9,
                            "wind_kph": 4.7,
                            "wind_degree": 15,
                            "wind_dir": "NNE",
                            "pressure_mb": 1011,
                            "pressure_in": 29.86,
                            "precip_mm": 0.2,
                            "precip_in": 0.01,
                            "humidity": 58,
                            "cloud": 85,
                            "feelslike_c": 28.2,
                            "feelslike_f": 82.8,
                            "windchill_c": 27,
                            "windchill_f": 80.6,
                            "heatindex_c": 28.2,
                            "heatindex_f": 82.8,
                            "dewpoint_c": 18.1,
                            "dewpoint_f": 64.6,
                            "will_it_rain": 0,
                            "chance_of_rain": 63,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 3.6,
                            "gust_kph": 5.8,
                            "uv": 6
                        },
                        {
                            "time_epoch": 1659708000,
                            "time": "2022-08-05 07:00",
                            "temp_c": 27.4,
                            "temp_f": 81.3,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 2.5,
                            "wind_kph": 4,
                            "wind_degree": 19,
                            "wind_dir": "NNE",
                            "pressure_mb": 1012,
                            "pressure_in": 29.88,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 56,
                            "cloud": 16,
                            "feelslike_c": 28.5,
                            "feelslike_f": 83.3,
                            "windchill_c": 27.4,
                            "windchill_f": 81.3,
                            "heatindex_c": 28.5,
                            "heatindex_f": 83.3,
                            "dewpoint_c": 17.8,
                            "dewpoint_f": 64,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 2.9,
                            "gust_kph": 4.7,
                            "uv": 7
                        },
                        {
                            "time_epoch": 1659711600,
                            "time": "2022-08-05 08:00",
                            "temp_c": 28.1,
                            "temp_f": 82.6,
                            "is_day": 1,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                                "code": 1063
                            },
                            "wind_mph": 3.8,
                            "wind_kph": 6.1,
                            "wind_degree": 29,
                            "wind_dir": "NNE",
                            "pressure_mb": 1012,
                            "pressure_in": 29.89,
                            "precip_mm": 0.6,
                            "precip_in": 0.02,
                            "humidity": 53,
                            "cloud": 74,
                            "feelslike_c": 29.1,
                            "feelslike_f": 84.4,
                            "windchill_c": 28.1,
                            "windchill_f": 82.6,
                            "heatindex_c": 29.1,
                            "heatindex_f": 84.4,
                            "dewpoint_c": 17.6,
                            "dewpoint_f": 63.7,
                            "will_it_rain": 1,
                            "chance_of_rain": 76,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 9,
                            "vis_miles": 5,
                            "gust_mph": 4.7,
                            "gust_kph": 7.6,
                            "uv": 6
                        },
                        {
                            "time_epoch": 1659715200,
                            "time": "2022-08-05 09:00",
                            "temp_c": 28.9,
                            "temp_f": 84,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.4,
                            "wind_kph": 5.4,
                            "wind_degree": 62,
                            "wind_dir": "ENE",
                            "pressure_mb": 1012,
                            "pressure_in": 29.89,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 50,
                            "cloud": 13,
                            "feelslike_c": 29.9,
                            "feelslike_f": 85.8,
                            "windchill_c": 28.9,
                            "windchill_f": 84,
                            "heatindex_c": 29.9,
                            "heatindex_f": 85.8,
                            "dewpoint_c": 17.5,
                            "dewpoint_f": 63.5,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 3.8,
                            "gust_kph": 6.1,
                            "uv": 7
                        },
                        {
                            "time_epoch": 1659718800,
                            "time": "2022-08-05 10:00",
                            "temp_c": 29.8,
                            "temp_f": 85.6,
                            "is_day": 1,
                            "condition": {
                                "text": "Patchy rain possible",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/176.png",
                                "code": 1063
                            },
                            "wind_mph": 2.7,
                            "wind_kph": 4.3,
                            "wind_degree": 101,
                            "wind_dir": "ESE",
                            "pressure_mb": 1012,
                            "pressure_in": 29.89,
                            "precip_mm": 0.1,
                            "precip_in": 0,
                            "humidity": 47,
                            "cloud": 84,
                            "feelslike_c": 30.8,
                            "feelslike_f": 87.4,
                            "windchill_c": 29.8,
                            "windchill_f": 85.6,
                            "heatindex_c": 30.8,
                            "heatindex_f": 87.4,
                            "dewpoint_c": 17.3,
                            "dewpoint_f": 63.1,
                            "will_it_rain": 1,
                            "chance_of_rain": 80,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 3.4,
                            "gust_kph": 5.4,
                            "uv": 6
                        },
                        {
                            "time_epoch": 1659722400,
                            "time": "2022-08-05 11:00",
                            "temp_c": 34.3,
                            "temp_f": 93.7,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.3,
                            "wind_kph": 6.8,
                            "wind_degree": 125,
                            "wind_dir": "SE",
                            "pressure_mb": 1012,
                            "pressure_in": 29.88,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 43,
                            "cloud": 10,
                            "feelslike_c": 37.5,
                            "feelslike_f": 99.5,
                            "windchill_c": 34.3,
                            "windchill_f": 93.7,
                            "heatindex_c": 37.5,
                            "heatindex_f": 99.5,
                            "dewpoint_c": 20,
                            "dewpoint_f": 68,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.9,
                            "gust_kph": 7.9,
                            "uv": 8
                        },
                        {
                            "time_epoch": 1659726000,
                            "time": "2022-08-05 12:00",
                            "temp_c": 35.6,
                            "temp_f": 96.1,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4,
                            "wind_kph": 6.5,
                            "wind_degree": 139,
                            "wind_dir": "SE",
                            "pressure_mb": 1011,
                            "pressure_in": 29.86,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 39,
                            "cloud": 8,
                            "feelslike_c": 38.8,
                            "feelslike_f": 101.8,
                            "windchill_c": 35.6,
                            "windchill_f": 96.1,
                            "heatindex_c": 38.8,
                            "heatindex_f": 101.8,
                            "dewpoint_c": 19.5,
                            "dewpoint_f": 67.1,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.7,
                            "gust_kph": 7.6,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659729600,
                            "time": "2022-08-05 13:00",
                            "temp_c": 35.1,
                            "temp_f": 95.2,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 3.6,
                            "wind_kph": 5.8,
                            "wind_degree": 162,
                            "wind_dir": "SSE",
                            "pressure_mb": 1010,
                            "pressure_in": 29.83,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 35,
                            "cloud": 16,
                            "feelslike_c": 36.6,
                            "feelslike_f": 97.9,
                            "windchill_c": 35.1,
                            "windchill_f": 95.2,
                            "heatindex_c": 36.6,
                            "heatindex_f": 97.9,
                            "dewpoint_c": 17.1,
                            "dewpoint_f": 62.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4,
                            "gust_kph": 6.5,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659733200,
                            "time": "2022-08-05 14:00",
                            "temp_c": 36.1,
                            "temp_f": 97,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.3,
                            "wind_kph": 6.8,
                            "wind_degree": 185,
                            "wind_dir": "S",
                            "pressure_mb": 1009,
                            "pressure_in": 29.8,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 19,
                            "feelslike_c": 37.1,
                            "feelslike_f": 98.8,
                            "windchill_c": 36.1,
                            "windchill_f": 97,
                            "heatindex_c": 37.1,
                            "heatindex_f": 98.8,
                            "dewpoint_c": 16,
                            "dewpoint_f": 60.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 4.9,
                            "gust_kph": 7.9,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659736800,
                            "time": "2022-08-05 15:00",
                            "temp_c": 37.1,
                            "temp_f": 98.8,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 4.7,
                            "wind_kph": 7.6,
                            "wind_degree": 204,
                            "wind_dir": "SSW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.77,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 27,
                            "cloud": 16,
                            "feelslike_c": 37.7,
                            "feelslike_f": 99.9,
                            "windchill_c": 37.1,
                            "windchill_f": 98.8,
                            "heatindex_c": 37.7,
                            "heatindex_f": 99.9,
                            "dewpoint_c": 14.9,
                            "dewpoint_f": 58.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 5.4,
                            "gust_kph": 8.6,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659740400,
                            "time": "2022-08-05 16:00",
                            "temp_c": 39.5,
                            "temp_f": 103.1,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 6,
                            "wind_kph": 9.7,
                            "wind_degree": 221,
                            "wind_dir": "SW",
                            "pressure_mb": 1007,
                            "pressure_in": 29.75,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 24,
                            "cloud": 11,
                            "feelslike_c": 40.7,
                            "feelslike_f": 105.3,
                            "windchill_c": 39.5,
                            "windchill_f": 103.1,
                            "heatindex_c": 40.7,
                            "heatindex_f": 105.3,
                            "dewpoint_c": 15.4,
                            "dewpoint_f": 59.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 6.9,
                            "gust_kph": 11.2,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659744000,
                            "time": "2022-08-05 17:00",
                            "temp_c": 38.9,
                            "temp_f": 102,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 7.6,
                            "wind_kph": 12.2,
                            "wind_degree": 222,
                            "wind_dir": "SW",
                            "pressure_mb": 1007,
                            "pressure_in": 29.73,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 24,
                            "cloud": 9,
                            "feelslike_c": 39.5,
                            "feelslike_f": 103.1,
                            "windchill_c": 38.9,
                            "windchill_f": 102,
                            "heatindex_c": 39.5,
                            "heatindex_f": 103.1,
                            "dewpoint_c": 14.4,
                            "dewpoint_f": 57.9,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 8.7,
                            "gust_kph": 14,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659747600,
                            "time": "2022-08-05 18:00",
                            "temp_c": 37.9,
                            "temp_f": 100.2,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 8.1,
                            "wind_kph": 13,
                            "wind_degree": 227,
                            "wind_dir": "SW",
                            "pressure_mb": 1007,
                            "pressure_in": 29.72,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 24,
                            "cloud": 8,
                            "feelslike_c": 37.9,
                            "feelslike_f": 100.2,
                            "windchill_c": 37.9,
                            "windchill_f": 100.2,
                            "heatindex_c": 37.9,
                            "heatindex_f": 100.2,
                            "dewpoint_c": 13.6,
                            "dewpoint_f": 56.5,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 9.2,
                            "gust_kph": 14.8,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659751200,
                            "time": "2022-08-05 19:00",
                            "temp_c": 36.8,
                            "temp_f": 98.2,
                            "is_day": 1,
                            "condition": {
                                "text": "Sunny",
                                "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
                                "code": 1000
                            },
                            "wind_mph": 8.7,
                            "wind_kph": 14,
                            "wind_degree": 244,
                            "wind_dir": "WSW",
                            "pressure_mb": 1006,
                            "pressure_in": 29.72,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 24,
                            "cloud": 7,
                            "feelslike_c": 36.5,
                            "feelslike_f": 97.7,
                            "windchill_c": 36.8,
                            "windchill_f": 98.2,
                            "heatindex_c": 36.5,
                            "heatindex_f": 97.7,
                            "dewpoint_c": 13,
                            "dewpoint_f": 55.4,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 10.1,
                            "gust_kph": 16.2,
                            "uv": 9
                        },
                        {
                            "time_epoch": 1659754800,
                            "time": "2022-08-05 20:00",
                            "temp_c": 35.5,
                            "temp_f": 95.9,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 8.3,
                            "wind_kph": 13.3,
                            "wind_degree": 252,
                            "wind_dir": "WSW",
                            "pressure_mb": 1007,
                            "pressure_in": 29.73,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 27,
                            "cloud": 7,
                            "feelslike_c": 35.2,
                            "feelslike_f": 95.4,
                            "windchill_c": 35.5,
                            "windchill_f": 95.9,
                            "heatindex_c": 35.2,
                            "heatindex_f": 95.4,
                            "dewpoint_c": 13.4,
                            "dewpoint_f": 56.1,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 9.8,
                            "gust_kph": 15.8,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659758400,
                            "time": "2022-08-05 21:00",
                            "temp_c": 34.7,
                            "temp_f": 94.5,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 8.1,
                            "wind_kph": 13,
                            "wind_degree": 257,
                            "wind_dir": "WSW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.76,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 28,
                            "cloud": 6,
                            "feelslike_c": 34.5,
                            "feelslike_f": 94.1,
                            "windchill_c": 34.7,
                            "windchill_f": 94.5,
                            "heatindex_c": 34.5,
                            "heatindex_f": 94.1,
                            "dewpoint_c": 13.7,
                            "dewpoint_f": 56.7,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 10.3,
                            "gust_kph": 16.6,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659762000,
                            "time": "2022-08-05 22:00",
                            "temp_c": 33.9,
                            "temp_f": 93,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 6.5,
                            "wind_kph": 10.4,
                            "wind_degree": 249,
                            "wind_dir": "WSW",
                            "pressure_mb": 1008,
                            "pressure_in": 29.78,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 30,
                            "cloud": 6,
                            "feelslike_c": 33.7,
                            "feelslike_f": 92.7,
                            "windchill_c": 33.9,
                            "windchill_f": 93,
                            "heatindex_c": 33.7,
                            "heatindex_f": 92.7,
                            "dewpoint_c": 13.9,
                            "dewpoint_f": 57,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 8.9,
                            "gust_kph": 14.4,
                            "uv": 1
                        },
                        {
                            "time_epoch": 1659765600,
                            "time": "2022-08-05 23:00",
                            "temp_c": 33.5,
                            "temp_f": 92.3,
                            "is_day": 0,
                            "condition": {
                                "text": "Clear",
                                "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
                                "code": 1000
                            },
                            "wind_mph": 6,
                            "wind_kph": 9.7,
                            "wind_degree": 252,
                            "wind_dir": "WSW",
                            "pressure_mb": 1009,
                            "pressure_in": 29.78,
                            "precip_mm": 0,
                            "precip_in": 0,
                            "humidity": 31,
                            "cloud": 6,
                            "feelslike_c": 33.3,
                            "feelslike_f": 91.9,
                            "windchill_c": 33.5,
                            "windchill_f": 92.3,
                            "heatindex_c": 33.3,
                            "heatindex_f": 91.9,
                            "dewpoint_c": 13.8,
                            "dewpoint_f": 56.8,
                            "will_it_rain": 0,
                            "chance_of_rain": 0,
                            "will_it_snow": 0,
                            "chance_of_snow": 0,
                            "vis_km": 10,
                            "vis_miles": 6,
                            "gust_mph": 8.7,
                            "gust_kph": 14,
                            "uv": 1
                        }
                    ]
                }
            ]
        }
    }
    let placeholderNavColor ={
        topNav:{
            backgroundColor:"#005986",
            inputBackgroundColor:"#337a9e",
        },
        middleNav:{
            backgroundColor:"#337a9e"
        },
        bottomNav:{
            backgroundColor:"#003550"
        },
        page:{
            backgroundColor:"rgb(139 191 203)"
        }
    }
    let dayNavColor ={
        topNav:{
            backgroundColor:"#005986",
            inputBackgroundColor:"#337a9e",
        },
        middleNav:{
            backgroundColor:"#337a9e"
        },
        bottomNav:{
            backgroundColor:"#003550"
        },
        page:{
            backgroundColor:"rgb(139 191 203)"
        }
    }
    let eveningNavColor ={
        topNav:{
            backgroundColor:"#722435",
            inputBackgroundColor:"#8e505d",
        },
        middleNav:{
            backgroundColor:"#8e505d"
        },
        bottomNav:{
            backgroundColor:"#441620"
        },
        page:{
            backgroundColor:"rgb(92 54 62)"
        }
    }
    let nightNavColor ={
        topNav:{
            backgroundColor:"#313050",
            inputBackgroundColor:"#5a5973",
        },
        middleNav:{
            backgroundColor:"#5a5973"
        },
        bottomNav:{
            backgroundColor:"#1d1d30"
        },
        page:{
            backgroundColor:"#494363"
        }
    }
    const [recievedData, setRecievedData] = useState(placeholderLocation)
    const [recieved,setRecieved]= useState(false)

    const [defaultZip, setDefaultZip] = useState(savedZip)
    const [navColor, setNavColor] = useState(placeholderNavColor)

    if(savedZip===null){
        localStorage.setItem("savedZip","89101")
    }
    

    let getData = (zip) => { 

        fetch(`https://api.weatherapi.com/v1/forecast.json?key=b28574dd6599479e944222901212812&q=${zip}&days=3&`)
        .then((response) => response.json())
        .then((data) => {
            console.log(data)
            console.log(data.current.last_updated.slice(11,data.current.last_updated.length-3))
            if(Number(data.current.last_updated.slice(11,data.current.last_updated.length-3))>6&&Number(data.current.last_updated.slice(11,data.current.last_updated.length-3))<17){
                setNavColor(dayNavColor)
            }else if(Number(data.current.last_updated.slice(11,data.current.last_updated.length-3))>17&&Number(data.current.last_updated.slice(11,data.current.last_updated.length-3))<23){
                setNavColor(eveningNavColor)
            }
            else{
                setNavColor(nightNavColor)
            }
            if(data["error"]===undefined){
                setRecievedData(data)
                setRecieved(true)
                localStorage.setItem("savedZip",zip)
            }else{
                setRecievedData(placeholderLocation)
                alert("invalid zip")
            }
        })
        .catch(error => {
            console.log(error)
        })

    }


    
    useEffect(() => 
    {
     getData(defaultZip);
    }, [""]);



    return(
        <BrowserRouter>
            <Routes>
                <Route index="/" element=
                    {<HomePage 
                        recievedData={recievedData}
                        defaultZip={defaultZip}
                        setDefaultZip={setDefaultZip}
                        getData={getData}
                        navColor={navColor}
                        recieved={recieved}
                    />} 
                />
                <Route path="/details" element=
                    {<HourlyInfoPage
                        recievedData={recievedData}
                        defaultZip={defaultZip}
                        setDefaultZip={setDefaultZip}
                        getData={getData}
                        navColor={navColor}
                    />}
                />
            </Routes>
        </BrowserRouter>
    )
}
